<mat-list class="tree">
  <ng-container *ngIf="nodes | async as _nodes">
    <mat-list-item
      *ngIf="showsRootDestinationRow"
      class="root-destination"
      (click)="selectRootFolderDestination()"
      [ngClass]="{ selected: isRootFolderDestinationSelected() }"
    >
      <mat-icon mat-list-icon class="icon small mat-secondary">folder</mat-icon>
      <div mat-line>
        <strong>{{ 'INTL_DATAROOM' | translate }}</strong>
      </div>
    </mat-list-item>
    <mat-list-item
      [disabled]="isDisabled(node)"
      *ngFor="let node of _nodes"
      (click)="onSelect(node)"
      (dblclick)="onOpen(node)"
      [ngClass]="{ selected: visuallySelectedNode?.id === node.id }"
    >
    <mat-icon mat-list-icon *ngIf="isFolder(node); else fileIcon" class="icon small" [ngClass]="getIconColor(node)">folder</mat-icon>
    <ng-template #fileIcon>
      <fa-icon mat-list-icon [icon]="icon?.file" class="icon small" [ngClass]="getIconColor(node)"></fa-icon>
    </ng-template>
    <div mat-line>
      <strong>{{ node?.name }}</strong>
    </div>
    </mat-list-item>
  </ng-container>
</mat-list>
